module.exports = __webpack_public_path__ + "img/sptg.a790b99c.png";